var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ancetId
    ? _c("div", { staticClass: "family-persons" }, [
        _c(
          "div",
          { staticClass: "family-persons__items" },
          [
            _vm.items
              ? _c("family-persons-list", {
                  attrs: { items: _vm.items },
                  on: { edit: _vm.editForm, delete: _vm.getItems },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "family-persons__add family-person-add" },
          [
            !_vm.visibleAddForm
              ? _c(
                  "a",
                  {
                    staticClass: "family-person-add__add-btn",
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function ($event) {
                        _vm.visibleAddForm = true
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" добавить\n    "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleAddForm
              ? _c("family-person-add", {
                  attrs: {
                    "ancet-id": this.ancetId,
                    "family-person": _vm.familyPersonInstance,
                  },
                  on: {
                    close: _vm.closeForm,
                    create: _vm.onFamilyPersonCreate,
                    update: _vm.onFamilyPersonUpdate,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }